import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';
import { MeetingAPI } from 'api/meeting/api';
import { Meeting } from 'api/meeting/types';

export const ALL_MEETINGS_KEY = ['all-meetings'];
export const useGetAllMeetings = (
  queryOptions: UseQueryOptions<
    Meeting[],
    unknown,
    Meeting[],
    typeof ALL_MEETINGS_KEY
  > = {},
): UseQueryResult<Meeting[]> =>
  useQuery(ALL_MEETINGS_KEY, () => MeetingAPI.getMeetings(), queryOptions);
